<template>
    <div class="hc-history-card">

        <div class="hc-accent-ribbon"></div>

        <div class="hc-header">
            <div class="hc-date">
                <span class="hc-dot"></span>
                <span class="hc-mono hc-date-text">{{ formatUnixTimestamp(props.time)?.split(' ')[0] }}</span>
            </div>
            <span class="hc-right-texts">
                <div v-if="props.activityStatus == 0 && props.returnTurnover" class="hc-status-badge hc-status-norewards">
                    {{ $t('activityStatus.noRewards') }}
                </div>
                <div v-else-if="props.activityStatus == 0 || props.activityStatus == 11" class="hc-status-badge hc-status-pending">
                    {{ $t('activityStatus.pending') }}
                </div>
                <div v-else-if="props.activityStatus == 1" class="hc-status-badge hc-status-completed">
                    {{ $t('activityStatus.completed') }}
                </div>
                <div v-else-if="props.activityStatus == 2" class="hc-status-badge hc-status-norewards">
                    {{ $t('activityStatus.noRewards') }}
                </div>
                <div v-else-if="props.activityStatus == 3" class="hc-status-badge hc-status-norewards">
                    {{ $t('activity.overdue') }}
                </div>
            </span>
        </div>

        <div class="hc-body">
            <div class="hc-gift-container">
                <img class="hc-gift-icon" src="@/assets/firstRecharge/gitfBoxhistoryFR2.png" alt="">
            </div>
            <div class="hc-info">
                <div class="hc-label-main">{{ $t('dayList.giftAmount') }}</div>
                <div class="hc-value-main hc-mono">
                    <span class="hc-currency">R$</span> {{ props.valueOne }}
                </div>
                <div class="hc-turnover-pill">
                    {{ $t('dayList.turnoverTimes') }} <span class="hc-mono">{{ props.valueTwo }}x</span>
                </div>
            </div>
        </div>

        <div class="hc-footer">
            <div class="hc-stat">
                <div class="hc-label-sub">{{ $t('activity.available') }}</div>
                <div class="hc-value-sub hc-mono">{{ formatCurrency(props.availableAmount) }}</div>
            </div>
            <div class="hc-divider"></div>
            <div class="hc-stat">
                <div class="hc-label-sub">{{ $t('activity.givenAmount') }}</div>
                <div class="hc-value-sub hc-mono">{{ formatCurrency(props.givenAmount) }}</div>
            </div>
        </div>

    </div>
</template>

<script setup lang="ts">
import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';

const props = defineProps({
    valueOne: {
        type: Number,
        default: 0
    },
    valueTwo: {
        type: Number,
        default: 0
    },
    time: {
        type: Number,
        default: 0
    },
    activityStatus: {
        type: Number,
        default: 0
    },
    returnTurnover: {
        type: Boolean,
        default: false
    },
    availableAmount: {
        type: Number,
        default: 0
    },
    givenAmount: {
        type: Number,
        default: 0
    }
});
</script>

<style scoped>

.hc-history-card {
    position: relative;
    background: linear-gradient(90deg, #3c0454 0%, #26023b 100%);
    border: 1px solid #821c82;
    border-radius: 12px;
    padding: 12px 16px;
    margin: 0 15px 10px;
    color: #fff;
    overflow: hidden;
}

.hc-accent-ribbon {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent 0%, #f744db 50%, transparent 100%);
    border-radius: 12px 12px 0 0;
}

.hc-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 8px;
    margin-bottom: 12px;
    border-bottom: 1px solid #80808070;
}

.hc-date {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #ffffff;
}

.hc-dot {
    width: 6px;
    height: 6px;
    background-color: #f744db;
    border-radius: 50%;
    flex-shrink: 0;
    box-shadow: 0 0 5px #f744db;
}

.hc-date-text {
    font-size: 13px;
    color: #ffffff;
    font-weight: 600;
}

.hc-right-texts {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.hc-status-badge {
    padding: 3px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 11px;
    text-align: center;
    white-space: nowrap;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
}

.hc-status-pending {
    background-color: #3264c8;
    border: 1.5px solid #6b9cf6;
    color: #fff;
    box-shadow: 0 2px 5px rgba(0,0,0,0.4), inset 0 0 5px rgba(107, 156, 246, 0.5);
}

.hc-status-completed {
    background-color: #2e8233;
    border: 1.5px solid #6ed174;
    color: #fff;
    box-shadow: 0 2px 5px rgba(0,0,0,0.4), inset 0 0 5px rgba(110, 209, 116, 0.5);
}

.hc-status-norewards {
    background-color: #c42d2d;
    border: 1.5px solid #ff6b6b;
    color: #fff;
    box-shadow: 0 2px 5px rgba(0,0,0,0.4), inset 0 0 5px rgba(255, 107, 107, 0.5);
}

.hc-body {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.hc-gift-container {
    width: 56px;
    height: 56px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(247, 68, 219, 0.05);
    border: 1px solid rgba(247, 68, 219, 0.15);
    border-radius: 18px; /* Squircle appearance */
    box-shadow: inset 0 2px 10px rgba(247, 68, 219, 0.05);
}

.hc-gift-icon {
    width: 65%;
    position: relative;
    z-index: 1;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.4));
}

.hc-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.hc-label-main {
    font-size: 11px;
    font-weight: 500;
    color: #b5aabf;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}

.hc-value-main {
    font-size: 22px; /* Emphasized as largest element */
    font-weight: 800;
    color: #f744db;
    line-height: 1.1;
    margin-bottom: 6px;
    text-shadow: 0 2px 8px rgba(247, 68, 219, 0.3);
}

.hc-currency {
    font-size: 14px;
    font-weight: 600;
    margin-right: 2px;
    color: #d1c5db;
}

.hc-turnover-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: #b5aabf;
}

.hc-turnover-pill .hc-mono {
    color: #f744db;
    font-weight: 700;
    background: rgba(247, 68, 219, 0.1);
    padding: 2px 6px;
    border-radius: 4px;
}

.hc-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(0, 0, 0, 0.2);
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    padding: 8px 16px;
    margin: 0 -16px -12px;
    border-radius: 0 0 12px 12px;
}

.hc-stat {
    flex: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.hc-label-sub {
    font-size: 10px;
    font-weight: 500;
    color: #8c7d99;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.hc-value-sub {
    font-size: 13px;
    font-weight: 700;
    color: #bea6d4;
}

.hc-divider {
    width: 1px;
    height: 24px;
    background: rgba(255, 255, 255, 0.08);
    flex-shrink: 0;
}

.hc-mono {
    font-weight: 600;
}

@media (max-width: 380px) {
    .hc-value-main {
        font-size: 22px;
    }
    .hc-gift-container {
        width: 54px;
        height: 54px;
        border-radius: 18px;
    }
    .hc-status-badge {
        font-size: 10px;
        padding: 2px 8px;
    }
}
</style>
